<template>
	<div class="viewport">
    <div class="col-lg-3 col-md-5 auth-form">
      <div class="card">
        <div class="card-body">
          <img class="auth-form__logo d-table mx-auto mb-3" src="img/icons/icon.png" alt="Shards Dashboards - Register Template">
          <h5 class="auth-form__title text-center mb-4">Restablecer contraseña</h5>
          <form>
            <div class="form-group mb-4">
              <label for="exampleInputEmail1">Dirección de correo electrónico</label>
              <input type="email" class="form-control" :class="error.email.status" placeholder="Correo electrónico" v-model="form.email">
              <div class="invalid-feedback">
              	{{ error.email.message }}
              </div>
              <small id="emailHelp" class="form-text text-muted text-center">
              	Recibirás un correo electrónico..
            	</small>
            </div>
            <button class="btn btn-pill btn-accent d-table mx-auto" @click.prevent="restore" v-if="isLoading==false">
            	Restablecer contraseña
          	</button>
						<div class="text-center" v-if="isLoading==true">
              <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
            </div>
          </form>
        </div>
      </div>
      <div class="auth-form__meta d-flex mt-4">
        <router-link to="/" class="mx-auto">Inicio de sesión.</router-link>
      </div>
    </div>
	</div>
</template>

<style>
	.viewport {
	  width: 100vw;
	  height: 100vh;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	}
</style>

<script>
	import axios from 'axios'
	export default {
		data() {
			return {
				isLoading: false,
				form: {
					email: ''
				},
				error: {
					email: {
						status: '',
						message: ''
					}
				}
			}
		},

		methods: {
			restore() {
				this.isLoading = true;
				this.error.email.status = '';
       			this.error.email.message = '';
						axios.post(`${process.env.VUE_APP_ROOT_API}/user/password/request`,{
							email: this.form.email
						})
					.then(response => {
						this.isLoading = false;
						this.$router.replace('/');
						this.$toasted.show('<i class="fas fa-envelope mr-2"></i> Correo electrónico enviado', { 
							theme: "toasted-primary", 
							position: "top-right", 
							duration : 2000
						});
					})
					.catch(err => {
						this.isLoading = false;
						switch (err.response.status) {
							case 401:
                this.error.email.status = 'is-invalid';
                this.error.email.message = 'El correo electrónico no se encuentra registrado.';
								break;
							case 422: 
                this.error.email.status = 'is-invalid';
                this.error.email.message = err.response.data.errors.email[0];
								break;
							case 500:
								this.$toasted.show('<i class="fas fa-exclamation-triangle"></i> Ha ocurrido un error inesperado.', { 
									theme: "toasted-primary", 
									position: "top-right", 
									duration : 2000
								});
								break;
						}
					})
			}
		}
	}
</script>